import {createTheme} from "@mui/material";

export const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#39b54a',
            light: '#63d568',
            dark: '#368c3a',
            contrastText: '#e0d6c9',
        },
        background: {
            default: '#171917',
            paper: '#2c302c',
        },
        text: {
            primary: '#f5f5f5',
            secondary: '#d1d1d1',
        },
        grey: {
            50: '#f9f9f9',
            100: '#e0e0e0',
            200: '#c2c2c2',
            300: '#a3a3a3',
            400: '#858585',
            500: '#666666',
            600: '#4d4d4d',
            700: '#333333',
            800: '#1f1f1f',
            900: '#0d0d0d',
        },
    },
    typography: {
        fontFamily: 'Inter, Arial, sans-serif',
        h1: {color: '#f5f5f5'},
        h2: {color: '#f5f5f5'},
        h3: {color: '#f5f5f5'},
        h4: {color: '#f5f5f5'},
        h5: {color: '#f5f5f5'},
        h6: {color: '#f5f5f5'},
        body1: {color: '#f5f5f5'},
        body2: {color: '#d1d1d1'},
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontWeight: 'bold',
                    padding: '8px 16px',
                    borderRadius: '8px',
                    minWidth: '140px',
                },
            },
            variants: [
                {
                    props: {variant: 'navButton'},
                    style: ({theme}) => ({
                        backgroundColor: 'transparent',
                        color: theme.palette.text.primary,
                        transition: theme.transitions.create(
                            ['background-color', 'color', 'box-shadow'],
                            {duration: theme.transitions.duration.short}
                        ),
                        '&:hover': {
                            color: theme.palette.primary.main,
                            backgroundColor: 'transparent',
                        },
                        '&.active': {
                            color: theme.palette.text.primary,
                            backgroundColor: theme.palette.primary.dark,
                            '&:hover': {
                                backgroundColor: theme.palette.primary.dark,
                            },
                        },
                    }),
                },
            ],
        },
    },
});

export const lightTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#39b54a',
            light: '#63d568',
            dark: '#368c3a',
            contrastText: '#332a25',
        },
        background: {
            default: '#e0d6c9',
            paper: '#f9f9f9',
        },
        text: {
            primary: '#1f1f1f',
            secondary: '#4d4d4d',
        },
        grey: {
            50: '#f9f9f9',
            100: '#e0e0e0',
            200: '#c2c2c2',
            300: '#a3a3a3',
            400: '#858585',
            500: '#666666',
            600: '#4d4d4d',
            700: '#333333',
            800: '#1f1f1f',
            900: '#0d0d0d',
        },
    },
    typography: {
        fontFamily: 'Inter, Arial, sans-serif',
        h1: {color: '#1f1f1f'},
        h2: {color: '#1f1f1f'},
        h3: {color: '#1f1f1f'},
        h4: {color: '#1f1f1f'},
        h5: {color: '#1f1f1f'},
        h6: {color: '#1f1f1f'},
        body1: {color: '#1f1f1f'},
        body2: {color: '#4d4d4d'},
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontWeight: 'bold',
                    padding: '8px 16px',
                    borderRadius: '8px',
                    minWidth: '140px',
                },
            },
            variants: [
                {
                    props: {variant: 'navButton'},
                    style: ({theme}) => ({
                        backgroundColor: 'transparent',
                        color: theme.palette.text.primary,
                        transition: theme.transitions.create(
                            ['background-color', 'color', 'box-shadow'],
                            {duration: theme.transitions.duration.short}
                        ),
                        '&:hover': {
                            color: theme.palette.grey[50],
                            backgroundColor: 'transparent',
                        },
                        '&.active': {
                            color: theme.palette.grey[50],
                            backgroundColor: theme.palette.primary.main,
                            '&:hover': {
                                backgroundColor: theme.palette.primary.main,
                            },
                        },
                    }),
                },
            ],
        },
    },
});

declare module '@mui/material/Button' {
    interface ButtonPropsVariantOverrides {
        navButton: true;
    }
}